<template>
  <div id="APP">
    <HeaderView v-if="headershow"/>
    <router-view class="routerView" />

    <div class="leftFloat" v-if="headershow">
      <a class="floatDiv" href="https://mp.weixin.qq.com/s/FM88qvCOfTUokDznkOefyA" target="_blank"><i class="iconfont">&#xe600;</i><p>使用说明</p></a>
      <div class="floatDiv"><i class="iconfont">&#xe8e9;</i><p>遇到问题</p><div class="code"><p>请添加管理员微信</p><img src="../src/assets/images/floatImg01.png" alt=""></div></div>
    </div>

    <FooterView v-if="footershow"/>
  </div>
</template>

<script lang="ts" setup>
import HeaderView from './components/HeaderView.vue'; 
import FooterView from './components/FooterView.vue'; 
import { useRoute } from 'vue-router'
import { ref,watchEffect } from "vue";
const route = useRoute()
const headershow=ref(true)
const footershow=ref(true)
watchEffect(()=>{     // 登录页面不显示头部
  if(route.path==="/LoginView"){
    headershow.value = false
    footershow.value = false
  }else{
    headershow.value = true
    footershow.value = true
  }
})

</script>
<style lang="scss" scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.routerView{
  min-height: calc(100vh - 110px);
  padding-bottom: 50px;
}

.leftFloat{
  width: 40px;
  height: 250px;
  position: fixed;
  right: 0;
  top: 50%;
  margin-top: -125px;
  .floatDiv{
    display: block;
    width: calc(100% - 24px);
    height: 92px;
    padding: 14px 12px;
    margin-bottom: 10px;
    background: #FFFFFF;
    box-shadow: 0px 2px 4px 1px rgba(0,0,0,0.16);
    border-radius: 2px;
    text-align: center;
    cursor: pointer;
    i{
      font-family: 'iconfont';
      color: var(--button_color);
      font-style: normal;
      font-size: 18px;
      display: block;
      margin-left: -1px;
      margin-bottom: 4px;
    }
    p{
      font-family: 'Microsoft YaHei, Microsoft YaHei';
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      line-height: 18px;
    }
  }
  .floatDiv:last-child{
    margin-bottom: 0;
    position: relative;
    .code{
      width: 160px;
      height: 158px;
      background: #FFFFFF;
      box-shadow: 0px 2px 4px 1px rgba(0,0,0,0.16);
      border-radius: 8px;
      padding: 20px 15px;
      text-align: center;
      position: absolute;
      top: 0;
      left: -205px;
      display: none;
      p{
        font-family: 'Microsoft YaHei, Microsoft YaHei';
        font-weight: bold;
        font-size: 16px;
        color: #333333;
      }
      img{
        width: 128px;
        height: 128px;
        margin-top: 12px;
      }
    }
  }
  div.floatDiv:last-child:hover{
    .code{
      display: block;
    }
  }
}
</style>
